const {enabled}=require('./transition.js');
const running=new Set();
document.querySelectorAll('.one-faq__items').forEach(group=>{
 const items=[...group.querySelectorAll('details')];
 items.forEach(item=>item.addEventListener('toggle',()=>{
  if(!item.open)return;
  items.forEach(other=>{if(other!==item)other.open=false;});
  if(!enabled())return;
  const answer=item.querySelector('.one-faq__answer');
  const animation=answer.animate([{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'none'}],{duration:280,easing:'cubic-bezier(.16,1,.3,1)'});
  running.add(animation);
  animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
 }));
});
addEventListener('onestep:motion',()=>{if(!enabled())running.forEach(animation=>animation.cancel());});
